import { AwsS3Bucket } from './aws-s3-bucket.package';
import { awsBucketConfig } from './libs/configs/configs';

const awsS3Bucket = new AwsS3Bucket(awsBucketConfig);

export { awsS3Bucket };
